module.exports = __webpack_public_path__ + "img/weaterNow.2958d390.png";